import axios from 'axios'
import axiosRetry from 'axios-retry'

const instance = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_PUBLIC_URL,
  timeout: 0,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  allowAbsoluteUrls: false // Added to prevent security vulnerability
})

axiosRetry(instance, {
  retries: 0
})

export const PublicApiClient = instance
